module.exports = __webpack_public_path__ + "img/sand-decal-17.775e2d6d.png";